import React from "react";
import style from "../Style.module.css";

const Pattern3 = ({ color = "#2F2F2F", ...props }) => {
  return (
    <svg
      className={style.svgBackground}
      width="100%"
      height="100%"
      viewBox="0 0 217 371"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMaxYMid meet"
      {...props}
    >
      <path
        d="M0 371H217V247.333V123.667V0H0C0 73.8717 28.4052 140.174 73.4536 185.5C28.4052 230.826 0 297.128 0 371Z"
        fill={color}
        opacity={0.1}
      />
    </svg>
  );
};

export default Pattern3;
